import React, { useEffect } from "react";
import CommentRespond from "./components/CommentRespond";
import Comments from "./components/Comments";
import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path
import { NavLink, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBlogDetails } from "../../../redux/actions/project";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function BlogDetail() {
  const dispatch = useDispatch();
  const { error, blog, message } = useSelector((state) => state.blog);

  let params = useParams();
  let id = params.id;

  useEffect(() => {
    if (error) {
      dispatch({ type: "clearError" });
    }
    if (message) {
      dispatch({ type: "clearMessage" });
    }

    dispatch(getBlogDetails(id));
  }, [error, message, dispatch]);
  AnimationFileLoader();

  return (
    <>
      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}

      {/* Blog Details */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row gx-60">
            <div className="col-lg-8">
              {/* Post Details */}
              <article className="post-details text-white">
                {/* Post Header */}
                <header className="entry-header">
                  <div
                    className="entry-thumbnail
                  "
                    style={{
                      height: "500px",
                    }}
                  >
                    <img
                      src={blog?.image?.url}
                      alt="blog post"
                      style={{
                        height: "500px",
                      }}
                    />
                  </div>

                  <h1 className="entry-title">{blog?.title}</h1>

                  <ul className="list-inline list-unstyled entry-meta">
                    <li>
                      <span>Post by : </span>
                      <NavLink to="#">{blog?.author}</NavLink>
                    </li>
                    <li>
                      <span>Posted On : </span>
                      <NavLink to="#">
                        <time
                          className="entry-date"
                          datetime={blog?.createdAt?.slice(0, 10)}
                        >
                          {blog?.createdAt?.slice(0, 10)}
                        </time>
                      </NavLink>
                    </li>
                    <li className="d-flex justify-items-center">
                      <span>Category:</span>
                      <p>{blog?.category?.category}</p>
                    </li>
                  </ul>
                </header>
                {/* End Post Header */}

                {/* Post Content */}
                <div className="entry-content">
                  <div dangerouslySetInnerHTML={{ __html: blog?.content }} />

                  {/* <div className="row">
                    <div className="col-sm-6">
                      <div className="example_img mb-4">
                        <img
                          src="/img/media/bd-2.png"
                          className="radius-10"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="example_img mb-4">
                        <img
                          src="/img/media/bd-3.png"
                          className="radius-10"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>

                  <p>
                    NFTs are non-fungible tokens. they are unique items that you
                    can't replace with something else. for examples NavLink one
                    of NavLink kind trading card is an NFT – you can't just
                    replace it with any other card. If you trade your card for
                    some other card you have something different which are often
                    the same as each other.
                  </p> */}
                </div>

                {/* End Post Content */}

                {/* Post Footer */}
                {/* <footer className="entry-footer border-top border-bottom py-3">
                  <div className="row">
                    <div className="col-sm-6">
                      {/* Tags */}
                {/* <div className="entry-tags">
                        <ul className="list-inline media m-0">
                          <li>Tags:</li>
                          <li className="media-body">
                            <NavLink to="#">Car</NavLink>
                            <NavLink to="#">Auto</NavLink>
                            <NavLink to="#">Trand</NavLink>
                            <NavLink to="#">Repair</NavLink>
                          </li>
                        </ul>
                      </div> */}
                {/* End Tags */}
                {/* </div> */}
                {/* <div className="col-sm-6"> */}
                {/* Widget Social Links */}
                {/* <div className="widget widget_social_links">
                        {/* Socials */}
                <div className="socials d-flex align-items-center style--two justify-content-sm-end mt-2 mt-sm-0">
                  <span>Share:</span>
                  <NavLink to="https://www.twitter.com/">
                    <img
                      src="/img/icons/twitter-round.svg"
                      alt=""
                      className="svg"
                    />
                  </NavLink>
                  <NavLink to="https://www.instagram.com/">
                    <img
                      src="/img/icons/instagram-round.svg"
                      alt=""
                      className="svg"
                    />
                  </NavLink>
                  <NavLink to="https://www.pinterest.com/">
                    <img
                      src="/img/icons/pinterest.svg"
                      alt=""
                      className="svg"
                    />
                  </NavLink>
                  <NavLink to="https://www.whatsapp.com/">
                    <img src="/img/icons/whatsapp.svg" alt="" className="svg" />
                  </NavLink>
                </div>
                {/* End Socials */}
                {/* </div>  */}
                {/* End Widget Social Links */}
                {/* </div> */}
                {/* </div> */}
                {/* </footer> */}
                {/* End Post Footer */}
              </article>
              {/* End Post Details */}

              {/* Post Author */}
              {/* <div className="post-author media section-bg mt-60">
                {/* Author Thumb */}
              {/* <div className="author-thumb">
                <img
                  alt=""
                  className="rounded-circle"
                  src="/img/media/post-author.png"
                />
              </div> */}
              {/* End Author Thumb */}

              {/* Author Info */}
              {/* <div className="author-info media-body">
                <h3 className="mb-3">Tyler Trevor</h3>
                <p>
                  Anefty trading card is an – you can't just replace it with any
                  other card. If you trade your it's card for some other card
                  you have something different, which are often the same as each
                  other contest over anefty.
                </p>

                {/* Socials */}
              {/* <div className="socials d-flex align-items-center style--two">
                <NavLink to="https://www.twitter.com/">
                  <img
                    src="/img/icons/twitter-round.svg"
                    alt=""
                    className="svg"
                  />
                </NavLink>
                <NavLink to="https://www.instagram.com/">
                  <img
                    src="/img/icons/instagram-round.svg"
                    alt=""
                    className="svg"
                  />
                </NavLink>
                <NavLink to="https://www.pinterest.com/">
                  <img src="/img/icons/pinterest.svg" alt="" className="svg" />
                </NavLink>
                <NavLink to="https://www.whatsapp.com/">
                  <img src="/img/icons/whatsapp.svg" alt="" className="svg" />
                </NavLink>
            </div> */}
              {/* End Socials */}
              {/* </div>  */}
              {/* Author Info */}
              {/* </div>  */}
              {/* End Post Author */}

              {/* Comments */}

              {/* <Comments /> */}

              {/* End Comments */}

              {/* Comment Respond */}
              {/* <CommentRespond /> */}
              {/* End Comment Respond */}
            </div>
            {/* <div className="col-lg-4">
              {/* Blog Sidebar */}
            {/* <div className="blog-sidebar mt-5 mt-lg-0"> */}
            {/* Widget Search */}
            {/* <div className="widget widget_search"> */}
            {/* Search Form */}
            {/* <form className="search-form style--two" action="#">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control mb-0"
                      placeholder="Search item…"
                    />
                    <button type="submit">
                      <img src="/img/icons/search.svg" className="svg" alt="" />
                    </button>
                  </div>
                </form> */}
            {/* End Search Form */}
            {/* </div> */}
            {/* End Widget Search */}

            {/* Widget Categories */}
            {/* <div className="widget widget_categories">
                <h3 className="widget widget-title">Categories</h3>

                <ul>
                  <li>
                    <NavLink to="#">Artwork</NavLink>05
                  </li>
                  <li>
                    <NavLink to="#">Painting</NavLink>09
                  </li>
                  <li>
                    <NavLink to="#">Colorpaint</NavLink>03
                  </li>
                  <li>
                    <NavLink to="#">Trypainting</NavLink>08
                  </li>
                </ul>
              </div> */}
            {/* End Widget Categories */}

            {/* Widget Advertise */}
            {/* <div className="widget widget_advertise">
                <NavLink to="#">
                  <img src="/img/ad.png" alt="" />
                </NavLink>
              </div> */}
            {/* End Widget Advertise */}

            {/* TagCloud */}
            {/* <div className="widget widget_tag_cloud">
                <h3 className="widget-title">Popular Tags</h3>

                <div className="tagcloud">
                  <NavLink to="#">color</NavLink>
                  <NavLink to="#">alignment</NavLink>
                  <NavLink to="#">space</NavLink>
                  <NavLink to="#">audio</NavLink>
                  <NavLink to="#">typography</NavLink>
                  <NavLink to="#">caption</NavLink>
                  <NavLink to="#">formetting</NavLink>
                  <NavLink to="#">fun</NavLink>
                  <NavLink to="#">HTML</NavLink>
                  <NavLink to="#">image</NavLink>
                  <NavLink to="#">post</NavLink>
                  <NavLink to="#">post format</NavLink>
                </div>
              </div> */}
            {/* End TagCloud */}
            {/* </div> */}
            {/* End Blog Sidebar */}
            {/* </div>  */}
          </div>
        </div>
      </section>
      {/* End Blog Details */}

      {/* Instafeed */}
      {/* <div className="insta_feed mt-n2 mb-2 ovx-hidden">
        <NavLink to="https://www.instagram.com/" className="btn">
          <img src="/img/icons/btn-instagram.svg" alt="" className="svg" />
          instagram
        </NavLink>
        <ul className="row g-2">
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta1.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta2.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta3.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta4.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta5.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta6.png" alt="" />
            </NavLink>
          </li>
        </ul>
      </div> */}

      {/* End Instafeed */}
    </>
  );
}

export default BlogDetail;
